export const PRODUCT = "PRODUCT";
export const PRODUCT_TYPES = "PRODUCT_TYPES";
export const GET_DOCTOR_TYPE = "GET_DOCTOR_TYPE";
export const CHANGE_ROUTER = "CHANGE_ROUTER";
export const SORT_DOCTORS = "SORT_DOCTORS";
export const SORT_PRODUCT = "SORT_PRODUCT";
